export const GameLogData = [
    {
        name: 'Planned Task #T2',
        cost: 200,
        grayAmount: 3,
        redAmount: 1,
        blueAmount: 0,
        value: 700,
        steps: 2,
        date: '22/4/2022',
        time: '12:32',
        mileStoneNumber: 19,
    },
    {
        name: 'Unplanned Task #2',
        cost: 250,
        grayAmount: 3,
        redAmount: 1,
        blueAmount: 2,
        value: 300,
        steps: 1,
        date: '22/4/2022',
        time: '12:32',
        mileStoneNumber: 18,
    },
    {
        name: 'Risk #5',
        cost: 500,
        grayAmount: 3,
        redAmount: 1,
        blueAmount: 0,
        value: 700,
        steps: 1,
        date: '22/4/2022',
        time: '20:32',
        mileStoneNumber: 15,
    },
    {
        name: 'Millstone',
        cost: 200,
        grayAmount: 3,
        redAmount: 1,
        blueAmount: 4,
        value: 250,
        steps: 12,
        date: '22/5/2022',
        time: '15:32',
        mileStoneNumber: 6,
    },
    {
        name: 'Gate #1',
        cost: 200,
        grayAmount: 3,
        redAmount: 1,
        blueAmount: 0,
        value: 700,
        steps: 3,
        date: '22/4/2022',
        time: '12:32',
        mileStoneNumber: 4,
    },
    {
        name: 'Planned Task #T2',
        cost: 300,
        grayAmount: 3,
        redAmount: 4,
        blueAmount: 4,
        value: 900,
        steps: 4,
        date: '28/4/2022',
        time: '12:12',
        mileStoneNumber: 2,
    },
];
